import React from 'react';
import { TablePagination } from "@mui/material";
import { makeStyles } from "@mui/styles";

const Pagination: React.FC<PaginationProps> = (props) => {
    const styles = useStyles();

    return (
        <div className={ styles.root }>
            <TablePagination
                component='div'
                count={ props.total || 0 }
                page={ (props.page || 1) - 1 }
                rowsPerPage={ props.size || 50 }
                rowsPerPageOptions={ [10, 25, 50, 100, 250, 500] }
                onPageChange={ (event, page) => props.onPageChange(page + 1) }
                onRowsPerPageChange={ (event) => props.onSizeChange(parseInt(event.target.value)) }
            />
        </div>
    );
}
export default React.memo(Pagination);

export interface PaginationProps {
    readonly page?: number;
    readonly size?: number;
    readonly total?: number;
    readonly onPageChange: (page: number) => void;
    readonly onSizeChange: (size: number) => void;
}

const useStyles = makeStyles(theme => ({
    root: {
        position: 'sticky',
        bottom: 0,
        backgroundColor: '#ffffff',
        borderTop: '1px solid ' + theme.palette.divider,
    }
}));